import React, {useEffect, useRef, useState} from 'react';
import {searchStore} from './store';
import {ReactComponent as PageLeft} from '@/assets/icons/chavron-left.svg';

console.log(PageLeft);
import {goBack} from '@utils';

function SearchIcon({className}: {className?: string}) {
  return (
    <svg
      width="24"
      className={className}
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.8759 9.93756C18.8759 11.9099 18.2356 13.7319 17.157 15.21L22.5971 20.6544C23.1343 21.1915 23.1343 22.0638 22.5971 22.601C22.06 23.1381 21.1877 23.1381 20.6506 22.601L15.2105 17.1566C13.7323 18.2395 11.9103 18.8754 9.93794 18.8754C5.00059 18.8754 1 14.8749 1 9.93756C1 5.00025 5.00059 0.999695 9.93794 0.999695C14.8753 0.999695 18.8759 5.00025 18.8759 9.93756ZM9.93794 16.1253C10.7505 16.1253 11.5552 15.9653 12.3059 15.6543C13.0566 15.3433 13.7388 14.8875 14.3134 14.313C14.888 13.7384 15.3438 13.0562 15.6547 12.3055C15.9657 11.5548 16.1257 10.7501 16.1257 9.93756C16.1257 9.12497 15.9657 8.32034 15.6547 7.56961C15.3438 6.81887 14.888 6.13674 14.3134 5.56216C13.7388 4.98757 13.0566 4.53178 12.3059 4.22082C11.5552 3.90986 10.7505 3.74981 9.93794 3.74981C9.12534 3.74981 8.32071 3.90986 7.56997 4.22082C6.81923 4.53178 6.13709 4.98757 5.5625 5.56216C4.98791 6.13674 4.53212 6.81887 4.22115 7.56961C3.91019 8.32034 3.75013 9.12497 3.75013 9.93756C3.75013 10.7501 3.91019 11.5548 4.22115 12.3055C4.53212 13.0562 4.98791 13.7384 5.5625 14.313C6.13709 14.8875 6.81923 15.3433 7.56997 15.6543C8.32071 15.9653 9.12534 16.1253 9.93794 16.1253Z"
        fill="black"
      />
    </svg>
  );
}

const CancelIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      {...props}
      fill="none">
      <g clipPath="url(#clip0_39367_24352)">
        <path
          d="M6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM4.10156 4.10156C4.32188 3.88125 4.67812 3.88125 4.89609 4.10156L5.99766 5.20312L7.09922 4.10156C7.31953 3.88125 7.67578 3.88125 7.89375 4.10156C8.11172 4.32188 8.11406 4.67812 7.89375 4.89609L6.79219 5.99766L7.89375 7.09922C8.11406 7.31953 8.11406 7.67578 7.89375 7.89375C7.67344 8.11172 7.31719 8.11406 7.09922 7.89375L5.99766 6.79219L4.89609 7.89375C4.67578 8.11406 4.31953 8.11406 4.10156 7.89375C3.88359 7.67344 3.88125 7.31719 4.10156 7.09922L5.20312 5.99766L4.10156 4.89609C3.88125 4.67578 3.88125 4.31953 4.10156 4.10156Z"
          fill="#9FA5AC"
        />
      </g>
      <defs>
        <clipPath id="clip0_39367_24352">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export function SearchInput(props: {
  value: string;
  onChange: (value: string) => void;
}) {
  const {value, onChange} = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocus, setIsFocus] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (value.length < 2) return;
    searchStore.addSearchQuery(value);
    inputRef.current?.blur();
  };
  const handleBack = () => {
    goBack();
  };
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  return (
    <>
      <div className="bg-white h-[3.25rem] flex px-3 gap-3 items-center shadow-[0px_2px_4px_0px_rgba(0,0,0,0.20)] appearance-none outline-0 sticky top-0 z-10">
        <PageLeft className="w-6 h-6" onClick={handleBack}></PageLeft>
        <form
          onSubmit={handleSubmit}
          className="flex-1 h-10 transition transition-100 px-4 py-3 bg-bg flex items-center gap-3 rounded-[2.5rem] border"
          style={{
            borderColor: isFocus ? '#9800F5' : '#dee1e9',
          }}>
          <SearchIcon className="w-[0.875rem] h-[0.875rem]" />
          <input
            type="search"
            value={value}
            ref={inputRef}
            onChange={e => onChange(e.target.value)}
            onFocus={() => {
              setIsFocus(true);
            }}
            inputMode="search"
            autoComplete="off"
            enterKeyHint="search"
            // @ts-ignore
            returnKeyType="search"
            placeholder="Game name / Provider"
            onBlur={() => {
              setIsFocus(false);
            }}
            className="w-full focus:outline-0 inline-block relative min-w-0 bg-transparent accent-[#9800F5]"
          />
          {value.length > 0 && (
            <CancelIcon className="w-4 h-4" onClick={() => onChange('')} />
          )}
        </form>
      </div>
      {value.length >= 2 ? null : (
        <div className="py-5 text-[#9baabb] text-sm font-medium text-center">
          Search requires at least 2 characters
        </div>
      )}
    </>
  );
}
